import React, { useState } from 'react';
import T from 'prop-types';
import { get, has } from 'lodash-es';
import hooks from 'hooksAlias';
import { useSelector, useDispatch } from 'react-redux';
import { Loading } from '@piggybank/core';
import { setApplicationSubmitResponseData } from 'srcAlias/client/state/actions/applicationSubmitActions';
import { TechnicalError, Refer, Accept } from './pages';
import useApplicationSubmitCall from '../../global/customHooks/useApplicationSubmitCall';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import useTrackEventAnalytics from 'srcAlias/client/global/customHooks/useTrackEventAnalytics';

export const Decision = ({ config }) => {
  const dispatch = useDispatch();
  const [segmentName] = config;
  const [applicationSubmitResponse, setApplicationSubmitResponse] = useState();

  const checkResponse = get(
    hooks,
    'validations.default.checkResponse.checkResponse',
    null
  );
  const applicationSubmitResponsePresent = get(
    hooks,
    'validations.default.checkResponse.applicationSubmitResponsePresent',
    null
  );
  useTrackEventAnalytics('onClick', 'applicationSubmitButtonClick');
  useTrackPageViewAnalytics('processingSubmit');
  useApplicationSubmitCall(setApplicationSubmitResponse);

  const pageToRender = checkResponse(applicationSubmitResponse);
  const applicationDecisionData = get(
    applicationSubmitResponse,
    'data.data',
    null
  );
  const customerData = useSelector((state) =>
    get(state, 'appDataReview.responseData.data', {})
  );

  if (applicationSubmitResponsePresent(applicationSubmitResponse)) {
    dispatch(setApplicationSubmitResponseData(applicationSubmitResponse));
  }
  const hasLoadingScreenContent = has(
    hooks,
    'eligibility.loading.LoadingScreenHook'
  );

  const LoadingScreenContent = get(
    hooks,
    'eligibility.loading.LoadingScreenHook',
    () => null
  );
  switch (pageToRender) {
    case 'ACCEPT_PAGE':
      return (
        <Accept
          segmentName={segmentName}
          pageName="accept"
          customerData={customerData}
          applicationDecisionData={applicationDecisionData}
        />
      );
    case 'REFER_PAGE':
      return (
        <Refer
          segmentName={segmentName}
          pageName="refer"
          customerData={customerData}
        />
      );
    case 'TECHNICAL_ERROR_PAGE':
      return (
        <TechnicalError segmentName={'decision'} pageName={'technicalError'} />
      );
    /* falls through */
    default:
      return (
        <Loading show={true}>
          {hasLoadingScreenContent && (
            <LoadingScreenContent path={'decision'} />
          )}
        </Loading>
      );
  }
};

Decision.propTypes = {
  config: T.arrayOf(T.oneOfType([T.string, T.object])),
};

export default Decision;
